// Phase 7 R1 — cancel a draft PO (writes po_canceled audit event).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useCancelPurchaseOrder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (poId: string) => {
      const { error } = await (supabase as any).rpc('cancel_purchase_order', { p_po_id: poId });
      if (error) throw error;
      return poId;
    },
    onSuccess: (poId) => {
      qc.invalidateQueries({ queryKey: ['purchase-orders'] });
      qc.invalidateQueries({ queryKey: ['purchase-order', poId] });
    },
  });
}
